import axios from 'axios'
import { baseUrl } from "./url.js"
import qs from  'qs'

// axios.defaults.baseURL =  "http://192.168.1.16:8092/vms"  // 换成你自己的请求地址
axios.defaults.baseURL = baseUrl  // 换成你自己的请求地址
axios.defaults.timeout = 60000
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8;multipart/form-data'
// axios.defaults.headers['Content-Type'] = 'application/json'

// // 请求拦截器
axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    // const token = store.state.token
    if (config.method === 'get') {
      config.data = {unused: 0} // 这个是关键点，加入这行就可以了  解决get  请求添加不上content_type
      //设置get请求,不设置的话，url的一些特殊字符传输的时候会报错
      let url = config.url
      // get参数编码
      if (config.method === 'get' && config.params) {
        url += '?'
        let keys = Object.keys(config.params)
        for (let key of keys) {
          url += `${key}=${encodeURI(config.params[key])}&`
        }
        url = url.substring(0, url.length - 1)
        config.params = {}
      }
      config.url = url
    }
    // token && (config.headers.Authorization = token)
    return config
  },
  error => {
    return Promise.error(error)
  })
//
// // 响应拦截器
// axios.interceptors.response.use(
//   response => {
//     if (response.status === 200) {
//       return Promise.resolve(response)
//     } else {
//       return Promise.reject(response)
//     }
//   },
//   // 服务器状态码不是200的情况
//   error => {
//     if (error.response.status) {
//       switch (error.response.status) {
//         // 401: 未登录
//         // 未登录则跳转登录页面，并携带当前页面的路径
//         // 在登录成功后返回当前页面，这一步需要在登录页操作。
//         case 401:
//           router.replace({
//             path: '/login',
//             query: { redirect: router.currentRoute.fullPath }
//           })
//           break
//         // 403 token过期
//         // 登录过期对用户进行提示
//         // 清除本地token和清空vuex中token对象
//         // 跳转登录页面
//         case 403:
//           Toast({
//             message: '登录过期，请重新登录',
//             duration: 1000,
//             forbidClick: true
//           })
//           // 清除token
//           localStorage.removeItem('token')
//           store.commit('loginSuccess', null)
//           // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
//           setTimeout(() => {
//             router.replace({
//               path: '/login',
//               query: {
//                 redirect: router.currentRoute.fullPath
//               }
//             })
//           }, 1000)
//           break
//         // 404请求不存在
//         case 404:
//           Toast({
//             message: '网络请求不存在',
//             duration: 1500,
//             forbidClick: true
//           })
//           break
//         // 其他错误，直接抛出错误提示
//         default:
//           Toast({
//             message: error.response.data.message,
//             duration: 1500,
//             forbidClick: true
//           })
//       }
//       return Promise.reject(error.response)
//     }
//   }
// )

// 下面的代码为axios的cancelToken知识的学习。
/* axios.interceptors.response.use((response) => {
  // 对响应的数据再做什么处理; 判断登录是否失效,判断其他错误;
  if(response.status == 500){
    console.log(response.status);
  }
  else if(response.status >= 400){
    console.log(response.status);
  }
  else if(response.status >= 300){
    console.log(response.status);
  }
  else if(response.status == 200){
    return response.data;
  }
  else{
    console.log(response.status);
  }
}, (err) => {
  if (axios.isCancel(err)) {
    console.log('取消本次请求', err.message); // err.message 是调用 source.cancel('取消成功'); 传入的参数
    return Promise.reject(err);
  } else {
    return Promise.reject(err);
  }
}); */

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
function get (url, params, headers, source) {
  headers = headers ? headers : {};
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params,
      headers: headers,
      // cancelToken: source ? source.token : ""
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err.data)
    })
  })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} data [请求时携带的参数]
 */
function post (url, data, headers, source) {
    var token = sessionStorage.getItem("geneSearchToken")
  headers = (headers && Object.keys(headers).length) ? headers : {'Content-Type':"application/json;charset=utf-8", 'token': token};
  return new Promise((resolve, reject) => {
      axios.post(url, data, {
        headers: headers,
        token: token ? token : ""
      }).then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
/* function post (url, data, headers) {
  headers = headers ? headers : {};
  return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(data,{ arrayFormat: 'repeat' }),{
          headers: headers
      }).then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
} */

function jsonPost (url, data, headers) {
    headers = headers ? headers : {'Content-Type':"application/json;charset=utf-8"};
    return new Promise((resolve, reject) => {
        axios.post(url, data,{
            headers: headers
        }).then(res => {
            resolve(res.data)
        })
            .catch(err => {
                reject(err.data)
            })
    })
}

export default { get, post, jsonPost }

/*
使用，在全局中声明。
import http from "..."
Vue.prototype.$http= http;


在vue文件中使用：
this.$http.get(url, { username: "张三", age: "12" }).then(function(res) { ... }).catch(function(err) { ... })
*/



// WEBPACK FOOTER //
// ./src/utils/http.js